export const environment = {
  production: true,
  version: '4.0.0'
};
